import api from "..";
import type { SignRequestBody, SignRequestResponseData } from "./types";

export const signRequest = async ( body: SignRequestBody ): Promise<SignRequestResponseData> => {

  const res = await api.post<SignRequestResponseData>("/accounts/upload/sign-request/",body);

  return res.data;
};
